import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    main: {
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    card: {
      width: '48rem',
      margin: theme.spacing(2),
      '& > *': {
        alignItems: 'start',
        padding: theme.spacing(0, 1),
      },
      '& .MuiFormHelperText-root.Mui-disabled': {
        color: 'inherit',
      },
    },
    input: {
      width: '100%',
      margin: theme.spacing(2, 0),
    },
    submitButton: {
      alignSelf: 'flex-end',
      margin: theme.spacing(2, 0, 0, 0),
      width: 'auto',
      minWidth: '13.3rem',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    formSent: {
      margin: theme.spacing(10, 0, 12),
      alignSelf: 'center',
      textAlign: 'center',
    },
  }),
)
